<div fxFill style="margin:5px">

  <div fxLayout="row" style="width: 100%; height: 100%">
    <div fxFlex="50" class="card">
      <div fxLayout="column" fxFlex="50">
        <div fxLayout="row" fxLayoutAlign="space-around center" style="width: 100%">
          <div>
            <kendo-label text="Level: " style="margin:6px">
              <kendo-dropdownlist
                [data]="levels"
                [(ngModel)]="selectedLevel"
                (valueChange)="levelValueChange($event)"
                name="selectedLevel"
                style="width:175px ; height: 29px; margin:5px">
              </kendo-dropdownlist>
            </kendo-label>
          </div>
          <div>
            <kendo-label text="Type: " style="margin:6px">
              <input (ngModelChange)="typeTextBoxChange($event)" [(ngModel)]="newTypeTextValue" name="type"
                     kendoTextBox style = "margin: 5px;
                     border-radius: 12px;"/>
            </kendo-label>
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-around center" style="margin-top: 20px">
          <button kendoButton (click)="addLevel()" [primary]="true" [disabled]="this.levelButtonBoolean" style="width: 64px;">Add</button>
          <button kendoButton (click)="clearLevel()" [primary]="true" style="width: 64px;">Clear</button>
          <button kendoButton (click)="deleteLevel()" [primary]="true" [disabled]="this.levelButtonBoolean">Delete
          </button>
          <button kendoButton (click)="updateLevel()" [primary]="true" [disabled]="this.levelButtonBoolean">Update
          </button>
        </div>
      </div>
      <div fxFlex="50">
        <div *ngIf="topHierarchyData">
          <kendo-treeview
            [nodes]="topHierarchyData"
            [(selectedKeys)]="selectedTopHierarchy"
            (selectionChange)="selectionChangeTopHierarchy($event)"
            textField="type"
            kendoTreeViewExpandable
            kendoTreeViewSelectable
            kendoTreeViewHierarchyBinding
            childrenField="items"
            style= " width:180px; border-bottom-left-radius: 10px;
                border-bottom-right-radius: 10px;
                border-top-left-radius: 10px;
                border-top-right-radius: 10px;">
          </kendo-treeview>
        </div>
      </div>
    </div>
    <div fxFlex="50" class="card">
      <div fxLayout="column" fxFlex="50">
        <app-hierarchy-bottom [hierarchyNumberArray]="hierarchyNumberArray"
                              [hierarchyTypeArray]="hierarchyTypeArray"
                              [hierarchyParentArray]="hierarchyParentArray"
                              [selectedType]="selectedType"
                              [selectedParent]="selectedParent"
                              [selectedNumber]="selectedNumber"
                              [selectedName]="selectedName"
                              [selectedStoreId]="selectedStoreId"
                              [selectedChain]="selectedChain"
                              [selectedDescription]="selectedDescription"
                              (numberDDL)="focus($event)"
                              (typeDDL)="focus($event)"
                              (parentDDL)="focus($event)"
                              (nameTB)="focus($event)"
                              (descTB)="focus($event)"
                              (formResults)="getResults($event)"
                              (hierarchyTypeDDChange)="hierarchyTypeDDChange($event)"
        ></app-hierarchy-bottom>
      </div>
      <div fxFlex="50">
        <div *ngIf="bottomHierarchyData">
          <kendo-treeview
            [nodes]="bottomHierarchyData"
            [(selectedKeys)]="selectedBottomHierarchy"
            (selectionChange)="selectedBottomHierarchyNode($event)"
            textField="type"
            kendoTreeViewExpandable
            kendoTreeViewSelectable
            kendoTreeViewHierarchyBinding
            childrenField="items">
          </kendo-treeview>


        </div>
      </div>
    </div>

    <div kendoDialogContainer></div>
  </div>
